import React, { useContext, useEffect, useState } from 'react'
import { navigate } from '@reach/router'
import UserContext from '../UserContext'
import Cookies from 'js-cookie'
import { Log, LogLevel } from './Common/Log'
import { getRootDomain, isValidHAPLink } from '../utilities'

const configData = window.CS_CONFIG

type LoginProps = {
    path: string
    default?: boolean
}

const Login: React.FC<LoginProps> = () => {
    const userContext = useContext(UserContext)

    // Hooks must be called unconditionally before any early returns.
    // Capture the one-time HAP journey flag so its cookie can be cleaned up.
    const [isHAP] = useState(() => Cookies.get('cs_hap_pending') === 'true')
    useEffect(() => {
        if (isHAP) {
            // Remove with the same domain used when setting, otherwise the browser
            // won't delete the parent-domain cookie. Only pass domain when
            // getRootDomain() returns a valid registrable domain — passing
            // domain: 'localhost' or an IP is invalid and can cause the remove to
            // miss the actual cookie.
            const rootDomain = getRootDomain()
            if (rootDomain) Cookies.remove('cs_hap_pending', { domain: rootDomain })
            // Also remove the host-only variant for safety (covers localhost/dev and
            // any cookie that was set without an explicit domain).
            Cookies.remove('cs_hap_pending')
        }
    }, [isHAP])

    if (!userContext.token && !!Cookies.get('cs_id_token')) {
        // eslint-disable-next-line no-console
        console.log('user has no context but has a token.  Attempting authenticate')
        userContext.authenticateUser(Cookies.get('cs_id_token'))

        return (
            <div className='no-records'>
                <img src='/spinning-circles.svg' alt='loading' />
            </div>
        )
    }
    else {
        // eslint-disable-next-line no-console
        console.log('User directed to login URL, are they already authed', !!userContext.token, !!Cookies.get('cs_id_token'), 'user: ', !!userContext.user, userContext.user.name)
        if (!!userContext.token && !!Cookies.get('cs_id_token') && !!userContext.user) {
            const callback = sessionStorage.getItem('path-callback')
            if (callback) {
                sessionStorage.removeItem('path-callback')
                setTimeout(() => void navigate(callback), 100)
            } else {
                setTimeout(() => void navigate('service-requests'), 100)
            }
        }
        else if (Cookies.get('cs_id_token'))
            Log(LogLevel.Error, `User not fetching properly ${JSON.stringify(userContext)}`)
    }

    return (
        <div className='login-page'>
            <h2>Select Login Method</h2>
            <a href={configData.ProviderLoginLink} title='Provider Login' className='button'>Provider Portal</a>
            <a href={configData.NonProviderLoginLink} title='Non-Provider Login' className='button'>Okta</a>
            {isValidHAPLink(configData.HAPLink) && (
                <a href={configData.HAPLink} title='MI HAP Portal' className='button hap' target='_blank' rel='noopener noreferrer'>MI HAP Portal</a>
            )}
        </div>
    )
}

export default Login
